export default function Game_Bouncing() {
  return (
    <div>
      <h1>Game_Bouncing Component</h1>
    </div>
  );
}
